import styled, { css } from 'styled-components';

import { getFontStyle } from '~components/Text/helper';

interface Props {
  isEntered?: boolean;
  isDisappeared?: boolean;
}

export const Wrapper = styled.div<Props>`
  position: absolute;
  top: 50%;
  left: 50%;
  padding: 10px 20px;
  background: rgba(244, 244, 244, 0.9);
  border-radius: 4px;
  text-align: center;
  transform: translate3d(-50%, -50%, 0);
  transition: all 0.2s;
  opacity: 0;
  ${getFontStyle('midium150_C1')};

  ${({ isEntered }) =>
    isEntered &&
    css`
      opacity: 1;
    `}

  ${({ theme }) => theme.media.mobile} {
    width: 180px;
    margin-top: -20px;
  }
`;
